<template>
  <span :class="clazz" @click="getSensitiveField">
    <slot></slot>
  </span>
</template>

<script>
  import AsyncValidator from 'async-validator'
  import { decrypt, getModalPageName, getMenuIdByRoute } from 'public/utils/common'
  import DecryptPlugin from 'public/utils/decrypt-plugin'

  const noop = _ => {}

  export default {
    name: 'kye-decrypt',
    props: {
      unauto: Boolean,
      newValidateRule: { // 监控/虚拟号/敏感字段校验，是否只根据表单字段信息校验，无需校验**
        type: Boolean,
        default: false
      }
    },
    inject: ['elForm'],
    created () {
      // this.autoDecryptFlag = new Set()
      this.decryptedValue = ''
      this.lock = false
      // let menu = this.$store.state.menus[this.$route.meta.tag]
      let menu = getMenuIdByRoute(this.$store, this.$route)
      this.menuId = menu && menu.id

      this.rewriteValidate()
    },
    mounted () {
      // this.checkLog()
    },
    updated () {
      // this.$watch('dataId', (val) => {
      //   this.autoDecryptFlag.delete(val)
      // })
      // 不启用自动解密 或者 不是监控字段 或者 已解密过，则不自动解密
      let filed = this.maskFiled.filed
      if (this.unauto || !this.maskFiled.mask || this.lock || filed === this.decryptedValue) {
        return
      }
      // 表单编辑时用户输入触发更新，此时 filed !== this.decryptedValue
      // 不是 el-input 组件正在输入引起的更新才触发自动解密
      let inputVm = this.$parent.$children.find(v => v && v.$options._componentTag === 'el-input')
      inputVm = inputVm && inputVm.focused
      if (!inputVm) {
        // const dataId = this.dataId
        // if (this.autoDecryptFlag.has(dataId)) {
        //   return
        // }
        // this.autoDecryptFlag.add(dataId)
        this.autoDecrypt()
      }
    },
    computed: {
      clazz () {
        const filed = this.maskFiled.filed
        return (this.maskFiled.mask || this.maskFiled.virtual) && filed && this.decryptedValue !== this.maskFiled.filed ? 'kye-label-click' : ''
      },
      pathArr () {
        return this.$parent.prop ? this.$parent.prop.split('.') : []
      },
      pathLen () {
        return this.$parent.prop ? this.$parent.prop.split('.').length - 1 : 0
      },
      model () {
        return this.$parent.form.model
      },
      module () {
        return this.$parent.$attrs['module-code'] || this.$parent.form.$attrs['module-code']
      },
      dataId () {
        return this.$parent.$attrs['biz-id'] || this.$parent.form.$attrs['biz-id']
      },
      fieldName () {
        return this.$parent.$attrs['field-name'] || this.$parent.prop
      },
      maskFiled () {
        let mask = null
        let virtual = null
        let maskSec = null
        let filed = null
        if (this.model) {
          let tempModel = this.model
          this.pathArr.forEach((t, i) => {
            if (i === this.pathLen) {
              filed = tempModel[t]
              if (tempModel[t + 'Mask']) {
                mask = tempModel[t + 'Mask']
              }
              if (tempModel[t + 'Virtual']) {
                virtual = tempModel[t + 'Virtual']
              }
              if (tempModel[t + 'MaskSec']) {
                maskSec = tempModel[t + 'MaskSec']
              }

              if (!tempModel[t] && tempModel.hasOwnProperty(t + 'MaskSec')) {
                this.hideItem()
              } else {
                this.hideItem(1)
              }
            }
            tempModel = tempModel[t]
          })
        }
        return { mask, virtual, maskSec, filed }
      }
    },
    methods: {
      rewriteValidate () {
        let parent = this.$parent
        // 重写FormItem中的validate方法
        parent.validate = (trigger, callback = noop) => {
          // 判断字段中包含**，则不做表单校验，并清空校验信息
          if (this.authRule()) {
            parent.clearValidate()
            callback()
            return true
          } else {
            parent.validateDisabled = false
            const rules = parent.getFilteredRule(trigger)
            if ((!rules || rules.length === 0) && parent.required === undefined) {
              callback()
              return true
            }
            parent.validateState = 'validating'
            const descriptor = {}
            if (rules && rules.length > 0) {
              rules.forEach(rule => {
                delete rule.trigger
              })
            }
            descriptor[parent.prop] = rules
            const validator = new AsyncValidator(descriptor)
            const model = {}
            model[parent.prop] = parent.fieldValue
            validator.validate(model, { firstFields: true }, (errors, invalidFields) => {
              parent.validateState = !errors ? 'success' : 'error'
              parent.validateMessage = errors ? errors[0].message : ''
              callback(parent.validateMessage, invalidFields)
              parent.elForm && parent.elForm.$emit('validate', parent.prop, !errors)
            })
          }
        }
      },
      /**
       * 根据表单中是否含有加密字段信息，判断是否是加密字段
       * 如果根据***判断加密字段，会存在用户输入***或者在原有的加密字段输入框中，会被框架拦截，认定是加密字段，从而导致无法触发业务线校验规则
       */
      authRule () {
        let parent = this.$parent
        const field = parent.fieldValue
        const { mask, virtual, maskSec } = this.maskFiled
        // 判断字段是否是权限字段
        if (this.newValidateRule) {
          return field && (mask || virtual || maskSec)
        }
        return field && String(field).includes('***')
      },
      hideItem (type) {
        // 敏感字段显示为6个※
        this.$nextTick(_ => {
          let el = this.$parent.$el
          if (el) {
            el.querySelector('.el-form-item__content').title = type === 1 ? '' : window.__ERPGLOABLECONFIG__.maskSec || '✽✽✽'
          }
        })
      },
      async getSensitiveField () {
        let type = this.maskFiled.mask ? 'mask' : this.maskFiled.virtual ? 'virtual' : ''
        if (!((type === 'mask' || type === 'virtual') && this.maskFiled.filed && this.decryptedValue !== this.maskFiled.filed)) {
          return
        }
        const params = {
          dataId: this.dataId,
          moduleCode: this.module,
          fieldName: this.fieldName,
          fieldContent: type === 'mask' ? this.maskFiled.mask : type === 'virtual' ? this.maskFiled.virtual : '',
          fieldNameStr: this.$parent.label || '',
          buttonName: getModalPageName(this),
          operateReason: this.$options.name
        }
        let data = await decrypt(params, type)
        if (data !== null) {
          this.decryptedValue = data || null
          this.updateModel(data || '')
          if (this.elForm && typeof this.elForm.$listeners.decrypt === 'function') {
            this.elForm.$listeners.decrypt({
              key: this.fieldName,
              decryptedValue: this.decryptedValue,
              type
            }, params)
          }
        }
      },
      // 更新Form组件中model
      updateModel (value) {
        let model = JSON.parse(JSON.stringify(this.model))
        let tempModel = model
        this.pathArr.forEach((t, i) => {
          if (i === this.pathLen) {
            tempModel[t] = value
          }
          tempModel = tempModel[t]
        })
        this.$parent.form.$listeners.update(model)
      },
      async autoDecrypt () {
        if (!DecryptPlugin.isCached(this.menuId, this.dataId, this.fieldName)) {
          return
        }
        this.lock = true
        try {
          // 防止接口重复提交而被终止
          let code = Math.floor(100 * Math.random())
          let data = await this.$http('syslog.sensitiveFieldViewLog.decrypt', [{
            fieldName: { dataId: this.dataId, fieldName: this.fieldName, code },
            fieldContent: this.maskFiled.mask
          }], false)
          if (data && data[0]) {
            data = data[0].fieldContent
            if (data !== null) {
              this.decryptedValue = data || null
              this.updateModel(data || '')
            }
          }
        } finally {
          this.lock = false
        }
      },
      checkLog () {
        if (!this.model || !this.dataId || !this.fieldName) {
          let str = `model:${!!this.model}, dataId:${!!this.dataId}, fieldName:${this.fieldName || this.$parent.label || ''}`
          let text = '[decrypt-plugin]自动解密条件检查 ' + str
          if (location.hostname === 'edge.uat.kye-erp.com') {
            let log = console.log
            log(text)
          } else {
            console.log(text)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/components/kye-decrypt/index.vue